import dataFetcher from "modules/dataFetcher";

import { nonProjectApi } from "services/api";
import store from "services/store";

import { getCurrentTenantUid } from "state/auth/selectors";
import { getCurrentContext } from "state/auth/selectors/common";

export const getContextRbacMappingFetcher = dataFetcher({
  selectors: ["preferences/clusterRbacSettings"],
  async fetchData() {
    const currentContext = getCurrentContext(store.getState());

    let response;
    if (currentContext?.isAdmin) {
      const tenantUid = getCurrentTenantUid(store.getState());
      response = await nonProjectApi.get(
        `v1/tenants/${tenantUid}/preferences/clusterRbacSettings`
      );
    }

    return response;
  },
});
